import React from 'react';
import {Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {StyledRating, StyledStack} from './styles';
import {FiveStarsRatingProps} from './types';

const {insatisfied, satisfied} = translations['pt-br'].privateFlow.fiveStarsRating;

export function FiveStarsRatings({hasError, ...ratingProps}: FiveStarsRatingProps) {
	return (
		<Stack gap={2} position="relative">
			<StyledRating {...ratingProps} size="large" $hasError={hasError} />
			<StyledStack>
				<Typography variant="body2" color="text.secondary">
					{insatisfied}
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{satisfied}
				</Typography>
			</StyledStack>
		</Stack>
	);
}
